import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Button from 'shopper/components/Button';

const PaginationButton = forwardRef(({ children, className, ...rest }, ref) => (
  <Button
    ref={ref}
    className={twMerge('mr-2 hidden px-2 md:flex md:px-4', className)}
    size="size2"
    type="neutral-ghost"
    {...rest}
  >
    {children}
  </Button>
));

PaginationButton.displayName = 'PaginationButton';

PaginationButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default PaginationButton;
